var map = {
	"./dashboard/dashboard.module.ngfactory": [
		"../../../../../src/app/pages/dashboard/dashboard.module.ngfactory.js",
		"dashboard.module"
	],
	"./pages/pages.module.ngfactory": [
		"../../../../../src/app/pages/pages.module.ngfactory.js",
		"pages.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1521087412/src/client/web-client/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main